import './index.scss';

import React from 'react';
import PropTypes from 'prop-types';

const ImageGallery = ({images, selectedImage, onSelect, round = false, emptyMessage = 'No existing images available'}) => {
	if (!images || images.length === 0) {
		return (
			<div className={`image-gallery image-gallery--empty${round ? ' image-gallery--round' : ''}`}>
				<p>{emptyMessage}</p>
			</div>
		);
	}

	return (
		<div className={`image-gallery${round ? ' image-gallery--round' : ''}`}>
			<div className="image-gallery__grid">
				{images.map((imageUrl, index) => (
					<button
						key={`${imageUrl}-${index}`}
						type="button"
						className={`image-gallery__item ${selectedImage === imageUrl ? 'image-gallery__item--selected' : ''}`}
						onClick={() => onSelect(imageUrl)}
					>
						<img src={imageUrl} alt={`Gallery item ${index + 1}`} />
					</button>
				))}
			</div>
		</div>
	);
};

ImageGallery.propTypes = {
	images: PropTypes.arrayOf(PropTypes.string).isRequired,
	selectedImage: PropTypes.string,
	onSelect: PropTypes.func.isRequired,
	round: PropTypes.bool,
	emptyMessage: PropTypes.string
};

ImageGallery.defaultProps = {
	selectedImage: null,
	round: false,
	emptyMessage: 'No existing images available'
};

export default ImageGallery;
